angular.module('contabilidad.polizas')
  .service('ProvisionGastosService', Service)

Service.$inject = ['$api', '$filter', '$schema']

function Service ($api, $filter, $schema) {
  var ProvisionGastosService = this

  ProvisionGastosService.obtenerInformacion = obtenerInformacion
  ProvisionGastosService.codificar = codificar

  function obtenerInformacion (fecha_inicio, fecha_fin, ids_clientes) {
    return $api.get('/kendu/contabilidad/polizas/provisionGastos', {
      fecha_inicio: fecha_inicio.toYMD(),
      fecha_fin: fecha_fin.toYMD(),
      ids_clientes: ids_clientes,
    }).then(function (data) {
      data = Object.values(data)
      return data.map(function (item) {
        return $schema(item, {
          Subtotal: 'number',
          Total: 'number',
          Importe_Tasa: 'number',
        })
      })
    })
  }

  var verificarCadena = $filter('rPad')

  function codificar (data, inicio) {
    var inicio_poliza = inicio
    var cadenaPrincipal = ''
    var cadA = 'P  AAAAMMDD    &      JJJJ 1 0          ' +
      'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n',

      fechaA,
      fechaB,
      factura

    try {
      data.forEach(function (item, indice) {

        fechaA = $filter('date')(item.fecha, 'yyyyMMdd')
        fechaB = verificarCadena($filter('date')(item.fecha, 'dd/MM/yyyy'), 15)
        factura = verificarCadena('F-' + item.folio, 15)
        if (indice === 0) {
          cadenaPrincipal += cadA
            .replace('&', '3')
            .replace('AAAAMMDD', fechaA)
            .replace('JJJJ', ('0000' + inicio_poliza).slice(-4))
            .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('PROVISION GASTOS', 60))
        }

        item.transacciones.forEach(function (trans, index) {
          if (index === 3) {
            if (!trans.naturaleza) trans.naturaleza = 'A'
          }

          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(trans.cuentaContable.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', factura)
            .replace('*', trans.naturaleza === 'A' ? 1 : 0)
            .replace('YYYYYYYYY', verificarCadena((+trans.importe).toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(item.nombre, 43))
        })

        inicio_poliza++

      })

      return cadenaPrincipal
    } catch (err) { // try
      console.error(err)
      return 'Error'
    }
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/ProvisionGastosService.js